import { Icon, Layout, Menu } from 'antd';
import { get, isString } from 'lodash';
import queryString from 'query-string';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import CommonTypeProps from '../../../common/CommonTypeProps';
import AccountLogsComponent from './account-logs/AccountLogsComponent';
import { ChangelogContainer } from './changelog/ChangelogContainer';
import { ExportActivityContainer } from './export-logs/ExportActivityContainer';
import AccessLogsComponent from './access-logs/AccessLogsComponent';
import { useSelector } from '../../../redux/store';
import { IState } from '../../../redux/reducer';
import { User } from 'o2o_layout/lib/common/model';
import DashboardPageLayoutV2 from '../../../layout/dashboard/DashboardPageLayoutV2';

export interface IConsoleUsersActivityProps extends CommonTypeProps {}

const ConsoleUsersActivityComponent = (props: IConsoleUsersActivityProps) => {
  const [selectedTab, setSelectedTab] = React.useState('');
  const user: User = useSelector((state: IState) => state.user);

  let title;
  switch (selectedTab) {
    case 'account-logs':
      title = 'User Account Log';
      break;
    case 'export-logs':
      title = 'Export Log';
      break;
    case 'change-logs':
      title = 'Change Log';
      break;
    case 'access-logs':
      title = 'Access Log';
      break;
    default:
      title = 'User Account Log';
  }

  useEffect(() => {
    const query = queryString.parse(props.location.search);
    if (query.tab && isString(query.tab)) {
      setSelectedTab(query.tab);
    } else {
      setSelectedTab('account-logs');
    }
  }, [props.location.search]);

  const checkIsYODYOrg = () => {
    const yodyOrgId = '232862ea98f40d3e0dc65da6acdca7a6';
    if (get(user.orgCtx, 'orgId') === yodyOrgId) {
      return true;
    } else {
      return false;
    }
  };

  const isYODYOrg = checkIsYODYOrg();

  const renderContentLayout = (version?: string) => {
    return (
      <Layout>
        <Layout.Sider style={{ background: '#fff' }} className={version === 'v2' ? 'main-menu-v3 menu-connection' : ''}>
          <Menu mode='inline' style={{ height: 'inherit' }} selectedKeys={[selectedTab]}>
            <Menu.Item key={'account-logs'}>
              <Link
                to={{
                  pathname: 'console-activity',
                  search: 'tab=account-logs',
                }}
              >
                User Account Log
              </Link>
            </Menu.Item>
            <Menu.Item key={'export-logs'}>
              <Link
                to={{
                  pathname: 'console-activity',
                  search: 'tab=export-logs',
                }}
              >
                Export Log
              </Link>
            </Menu.Item>
            <Menu.Item key={'change-logs'}>
              <Link
                to={{
                  pathname: 'console-activity',
                  search: 'tab=change-logs',
                }}
              >
                Change Log
              </Link>
            </Menu.Item>
            {!isYODYOrg && (
              <Menu.Item key={'access-logs'}>
                <Link
                  to={{
                    pathname: 'console-activity',
                    search: 'tab=access-logs',
                  }}
                >
                  Access Log
                </Link>
              </Menu.Item>
            )}
          </Menu>
        </Layout.Sider>

        <Layout.Content style={{ overflow: 'hidden' }} className='pl30 pt10'>
          {selectedTab === 'account-logs' ? <AccountLogsComponent {...props} /> : null}

          {selectedTab === 'export-logs' ? <ExportActivityContainer {...props} /> : null}

          {selectedTab === 'change-logs' ? <ChangelogContainer {...props} /> : null}

          {selectedTab === 'access-logs' ? <AccessLogsComponent {...props} /> : null}
        </Layout.Content>
      </Layout>
    );
  };

  return (
    <DashboardPageLayoutV2
      props={props}
      selectedLeftNavStandard='activity'
      selectedSubMenuStandard='console'
      breadcrumbItemsStandard={[{ title: 'Home', path: '/' }, { title: 'Admin' }, { title: 'Activities' }]}
      breadcrumbItemsModern={[
        { title: 'Account', path: '/' },
        { title: 'Activities', path: '/console-activity' },
        { title: title },
      ]}
      pageTitle='Activities'
      renderContentLayout={renderContentLayout}
      metaTitle={props.ui.meta.title}
      pageTitleIcon={
        <Icon
          component={() => (
            <svg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M10.9556 10.6278L11.2922 10.5037C10.2352 9.98287 8.95914 9.6549 7.50143 9.6549C2.98288 9.6549 0.207764 12.8153 0.207764 15.0158C0.207764 15.8908 0.821556 16.2956 2.12096 16.2956H9.70681C9.67271 16.0809 9.65626 15.8513 9.65626 15.6035V15.2052H1.80101C1.48105 15.2052 1.36352 15.1203 1.36352 14.8852C1.36352 13.3638 3.57711 10.7519 7.50143 10.7519C8.48527 10.7519 9.36152 10.9156 10.1224 11.1848C10.3248 10.9499 10.5998 10.7591 10.9556 10.6278ZM7.51447 8.54489C9.49298 8.54489 11.0862 6.80147 11.0862 4.64009C11.0862 2.51797 9.49298 0.833313 7.51447 0.833313C5.54252 0.833313 3.93624 2.54409 3.93624 4.6532C3.93624 6.80796 5.53596 8.54489 7.51447 8.54489ZM7.51447 7.4544C6.18896 7.4544 5.09198 6.22684 5.09198 4.6532C5.09198 3.12523 6.1824 1.92377 7.51447 1.92377C8.84654 1.92377 9.93047 3.10565 9.93047 4.64009C9.93047 6.21381 8.84005 7.4544 7.51447 7.4544ZM15.5606 11.0258C15.1894 10.8904 14.8482 10.766 14.6384 10.6866C14.3837 10.6018 14.0833 10.5952 13.7961 10.7128C13.6258 10.7763 13.3468 10.8769 13.0318 10.9905C12.4405 11.2037 11.7226 11.4625 11.3605 11.6073C10.8708 11.8032 10.6945 12.0971 10.6945 12.5868V15.6231C10.6945 17.1706 11.5825 17.7387 13.8679 19.0708C14.0573 19.1818 14.3706 19.2144 14.6123 19.0708C16.9042 17.7322 17.7922 17.1706 17.7922 15.6231V12.5868C17.7922 12.0971 17.616 11.8032 17.1262 11.6073C16.7847 11.4723 16.1366 11.2359 15.5606 11.0258ZM13.7112 15.8973L15.768 13.0569C15.8594 12.9263 15.9966 12.8414 16.1728 12.8414C16.4341 12.8414 16.6561 13.0504 16.6561 13.3181C16.6561 13.4095 16.6169 13.514 16.5516 13.6119L14.1356 16.9617C14.0507 17.0727 13.9071 17.1445 13.7308 17.1445C13.6002 17.1445 13.45 17.0857 13.3455 16.9747L11.9416 15.4337C11.8502 15.3357 11.811 15.1921 11.811 15.0811C11.811 14.8069 12.02 14.5979 12.2877 14.5979C12.4575 14.5979 12.5816 14.6828 12.6664 14.7677L13.7112 15.8973Z'
                fill='currentColor'
              />
            </svg>
          )}
        />
      }
    />
  );
};

export default ConsoleUsersActivityComponent;
